<template>
   <div>
        <button @click="clickHandler" v-if="auth && !success" class="update-button">
            <i :class="{ 'uk-icon-spin': isLoading }" class="uk-icon-refresh"></i> 
            <slot name="default">Обновить информацию</slot>
        </button>
        <span v-if="auth && success" class="success">
            <i class="uk-icon-check"></i>
            <slot name="success">Информация актуальна</slot>
        </span>
        <span class="demo" v-if="!auth">
            <i class="uk-icon-remove"></i>
            В демо-режиме обновление информации недоступно.
        </span>
   </div>
</template>

<script>
export default {
    props: {
        isLoading: {
            type: Boolean,
            default:false
        },
        success: {
            type: Boolean,
            default: false
        },
        clickHandler: {
            type: Function,
            default: () => {}
        }
    }
}
</script>

<style lang="sass" scoped>
.update-button
    background: none
    border: none
    color: #3498DB
    font-size: 16px
    cursor: pointer
    border-bottom: dashed 1px rgba(52, 152, 219,0.2)
    text-decoration: none
    padding: 0
    &:hover
        color: rgba(231, 76, 60,1.0)
        border-color: rgba(231, 76, 60,0.2)
.demo
    color: rgb(231, 76, 60)
    display: inline-block
    font-size: 16px
.success
    color: rgb(39, 174, 96)
    display: inline-block
    font-size: 16px
</style>